import React, { useState } from "react";
import { td } from "../../Shared/Styles";
import { formatDate } from "../ProductDetails";

export default function LapseTableData(lapseDetails) {
  const [lapseTableData] = useState(lapseDetails.ltd);

  if (lapseTableData !== undefined) {
    return lapseTableData.map((data) => {
      return (
        <>
          <React.Fragment>
            <div>
              <tbody>
                <tr>
                  <td style={td}>{data?.benefitType}</td>
                  <td style={td}>{data?.commencementDate ? formatDate(data.commencementDate) : ""}</td>
                  <td style={td}>${data?.annualPremium}</td>
                  <td style={td}>{data?.lapseTransactionDate ? formatDate(data.lapseTransactionDate) : ""}</td>
                  <td style={td}>{data?.timeInForce}</td>
                  <td style={td}>{data?.daysOutOfForce}</td>
                  <td style={td}>{data?.lapseDescription}</td>
                </tr>
              </tbody>
            </div>
          </React.Fragment>
        </>
      );
    });
  }
}
